import { z } from "zod";

/**
 * Benachrichtigungen je Person und Kunde: je Thema sofort, in der täglichen Zusammenfassung oder gar nicht,
 * dazu ein Wochenbericht. Grundlage sind die Punkte aus „Handlungsbedarf“ plus eingebuchte Wareneingänge.
 */
export const NOTIFICATION_TOPICS = {
  critical: { label: "Dringendes", description: "Shop getrennt, Aufträge nicht übertragen, Artikel blockiert oder ausverkauft, Zolldaten fehlen" },
  orders: { label: "Zurückgehaltene Aufträge", description: "Adresse prüfen, unbekannte Artikel, eigene Regeln, Aufträge warten auf Ware" },
  stock: { label: "Artikel & Bestand", description: "Artikel erreichen den Bestellpunkt, MHD läuft ab, Artikel nicht freigegeben oder vom Lager abgelehnt" },
  inbounds: { label: "Wareneingänge", description: "Ware eingebucht, Abweichungen, überfällige Anlieferungen" },
  returns: { label: "Retouren-Klärfälle", description: "Rücksendung konnte nicht normal verarbeitet werden" },
} as const;
export type NotificationTopic = keyof typeof NOTIFICATION_TOPICS;
export const NOTIFICATION_TOPIC_KEYS = Object.keys(NOTIFICATION_TOPICS) as NotificationTopic[];
export type NotificationMode = "instant" | "daily" | "off";

export const notificationSettingsSchema = z.object({
  topics: z
    .object({
      critical: z.enum(["instant", "daily", "off"]).default("instant"),
      orders: z.enum(["instant", "daily", "off"]).default("daily"),
      stock: z.enum(["instant", "daily", "off"]).default("daily"),
      inbounds: z.enum(["instant", "daily", "off"]).default("instant"),
      returns: z.enum(["instant", "daily", "off"]).default("instant"),
    })
    .prefault({}),
  /** Uhrzeit (Europe/Berlin) der täglichen Zusammenfassung und des Wochenberichts (montags) */
  dailyHour: z.number().int().min(5).max(20).default(7),
  /** nur werktags (Mo–Fr) zusammenfassen */
  weekdaysOnly: z.boolean().default(true),
  weekly: z.boolean().default(true),
});
export type NotificationSettings = z.infer<typeof notificationSettingsSchema>;
export const DEFAULT_NOTIFICATIONS: NotificationSettings = notificationSettingsSchema.parse({});

/** Thema eines Handlungsbedarf-Punkts: alles Dringende gesammelt, sonst nach Bereich (Konto: eigene Erinnerungen) */
export function topicOfAction(item: { severity: string; area: string }): NotificationTopic | null {
  if (item.severity === "critical") return "critical";
  if (item.area === "orders") return "orders";
  if (item.area === "stock" || item.area === "products") return "stock";
  if (item.area === "inbounds") return "inbounds";
  if (item.area === "returns") return "returns";
  if (item.area === "connections") return "critical";
  return null;
}
